import { useState, useEffect } from 'react';

export default function FinalCTA() {
  const [count, setCount] = useState(7);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((c) => (c > 3 ? c - 1 : 7));
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="final-cta" className="relative py-24 md:py-36 overflow-hidden bg-[#06060b]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20luxury%20dark%20background%20with%20golden%20light%20rays%20and%20deep%20navy%20atmosphere%2C%20premium%20bokeh%20particles%2C%20cinematic%20lighting%2C%20ultra%20high%20end%20aesthetic%2C%20minimalist%20dark%20gold%20gradient%2C%20no%20people%2C%20no%20text%2C%20pure%20atmosphere&width=1440&height=800&seq=finalcta01&orientation=landscape"
          alt="background"
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#06060b]/80 via-[#06060b]/60 to-[#06060b]/90" />
      </div>

      {/* Glow orbs */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4af37]/8 rounded-full blur-[150px] pointer-events-none" />
      <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] bg-[#00d9ff]/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 md:px-8 text-center">
        {/* Urgency badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-red-500/30 bg-red-500/10 text-red-400 text-xs font-bold uppercase tracking-widest mb-8 animate-pulse">
          <i className="ri-alarm-warning-line"></i>
          Sınırlı sayıda kurulum alınmaktadır — Kalan: {count} slot
        </div>

        {/* Headline */}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-5 leading-tight">
          Sadece Site Değil,{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] via-[#f4d03f] to-[#d4af37]">
            Satış Sistemi
          </span>
        </h2>

        <p className="text-white/60 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Kampanyalarınızı yöneten, ziyaretçinizi yönlendiren ve veri sağlayan platform. Bir kez kurulur, sürekli çalışır.
        </p>

        {/* Feature pills */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-10">
          {[
            { icon: 'ri-focus-3-line', text: 'Kampanya Odaklı' },
            { icon: 'ri-filter-3-line', text: 'Funnel Yapısı' },
            { icon: 'ri-bar-chart-2-line', text: 'Gerçek Zamanlı Analiz' },
            { icon: 'ri-megaphone-line', text: 'Reklam Entegrasyonu' },
            { icon: 'ri-user-add-line', text: 'Lead Toplama' },
          ].map((f, i) => (
            <div key={i} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-white/50 text-xs">
              <i className={`${f.icon} text-[#d4af37] text-sm`}></i>
              {f.text}
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://wa.me/905402470724?text=Smart%20Hizmet%20Sat%C4%B1%C5%9F%20Platformu%20Kurdurmak%20%C4%B0stiyorum"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative px-10 py-4 rounded-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-black text-base hover:opacity-90 transition-all duration-200 cursor-pointer whitespace-nowrap overflow-hidden flex items-center gap-2"
          >
            <span className="relative z-10 flex items-center gap-2">
              <i className="ri-whatsapp-line"></i>
              Bu Sistemi İstiyorum
            </span>
            <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500 skew-x-12" />
          </a>

          <button
            onClick={() => scrollTo('yonetim-paneli')}
            className="px-10 py-4 rounded-full border border-[#00d9ff]/50 text-[#00d9ff] font-bold text-base hover:bg-[#00d9ff]/10 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-dashboard-3-line"></i>
            Demo Paneli Gör
          </button>
        </div>

        {/* Trust signals */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-white/25 text-xs">
          {[
            { icon: 'ri-shield-check-line', text: 'Güvenli Kurulum' },
            { icon: 'ri-customer-service-2-line', text: '7/24 Destek' },
            { icon: 'ri-time-line', text: '48 Saat İçinde Yayın' },
          ].map((t, i) => (
            <div key={i} className="flex items-center gap-1.5">
              <i className={`${t.icon} text-[#d4af37]/40 text-sm`}></i>
              {t.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
